module.exports = __webpack_public_path__ + "static/flags/IL-d57b4a98845f015cb274653fb3dd5ba7.gif";